import axios from 'index/axios'

// 查询用户在项目中的数据权限
export function getPermissions(data) {
    return axios.post('/ProjectDataPermission/project/permission/list', data)
}

// 保存用户在项目中的数据权限（覆盖式）
export function savePermissions(data) {
    return axios.post('/ProjectDataPermission/project/permission/save', data)
}

// 删除单条权限记录
export function deletePermission(data) {
    return axios.post('/ProjectDataPermission/project/permission/delete', data)
}

// 获取用户可见的经销商ID列表
export function getVisibleDealers(data) {
    return axios.post('/ProjectDataPermission/project/permission/dealers', data)
}
